import { z } from 'zod';
import { dateSchema } from '../../validation';

/**
 * @deprecated Part of the legacy `User.devices[]` push-token registry.
 * Multi-device push is owned by OneSignal subscriptions under
 * `external_id = User._id`. See
 * [`docs/notifications.md`](../../../../../docs/notifications.md)
 * § "Deprecating `User.devices` / `oneSignalId`".
 */
export const deviceTypeSchema = z.enum(['phone', 'laptop', 'tablet']);
/** @deprecated See {@link deviceTypeSchema}. */
export type DeviceType = z.infer<typeof deviceTypeSchema>;

/**
 * @deprecated Part of the legacy `User.devices[]` push-token registry.
 * See {@link deviceTypeSchema}.
 */
export const deviceStatusSchema = z.enum(['active', 'inactive']);
/** @deprecated See {@link deviceStatusSchema}. */
export type DeviceStatus = z.infer<typeof deviceStatusSchema>;

/**
 * @deprecated Legacy push / OneSignal subscription token string.
 * Prefer `OneSignal.login(User._id)` + send by `external_id`.
 * See [`docs/notifications.md`](../../../../../docs/notifications.md)
 * § "Deprecating `User.devices` / `oneSignalId`".
 */
export const currentDeviceToken = z.coerce.string().trim().min(1);

/**
 * @deprecated Legacy per-device push-token row on `User.devices[]`.
 * Not a real "signed-in session" — auth sessions live on
 * `RefreshSession`. OneSignal owns multi-device push subscriptions.
 * See [`docs/notifications.md`](../../../../../docs/notifications.md)
 * § "Deprecating `User.devices` / `oneSignalId`".
 */
export const userDeviceSchema = z.object({
  /** @deprecated Push / notification device token. */
  token: currentDeviceToken,
  /** @deprecated Device form factor — unused by the current send path. */
  type: deviceTypeSchema,
  /**
   * @deprecated Was meant as signed-in vs signed-out for this token.
   * Real session lifecycle is `RefreshSession`.
   */
  status: deviceStatusSchema,
  /** @deprecated Last time this push token was written on sign-in. */
  lastSignIn: dateSchema,
});
/** @deprecated See {@link userDeviceSchema}. */
export type UserDevice = z.infer<typeof userDeviceSchema>;
